




import { Component, Prop, Vue } from 'vue-property-decorator';
import { MetaInfo } from 'vue-meta';

import { LoginScope } from '@/constants/xsolla';
import { NoRobots } from '@/constants/meta';
import { parseStateParams } from '@/helpers/auth';
import { Apps } from '@/constants/apps';

@Component({
  metaInfo(): MetaInfo {
    return {
      meta: [NoRobots],
    };
  },
})
export default class AuthCallback extends Vue {
  @Prop({ type: String })
  readonly code?: string;

  @Prop({ type: String })
  readonly state?: string;

  @Prop({ type: String })
  readonly scope?: string;

  get stateParams() {
    const state = typeof this.state === 'string' ? decodeURIComponent(this.state) : '';

    return parseStateParams(state);
  }

  beforeMount() {
    this.processCallback().catch(() => {
      this.$router.push({ name: 'main' });
    });
  }

  getAppNameFromParams(): Apps | undefined {
    let result;
    Object.values(Apps).forEach(appName => {
      if (this.stateParams.from?.includes(appName)) {
        result = appName;
      }
    });
    return result;
  }

  async processCallback() {
    const appName = this.getAppNameFromParams();
    if (appName === undefined) {
      return;
    }

    if (!this.checkRequestValid()) {
      throw new Error('Invalid request');
    }

    return this.$oauth
      .generateToken(appName, this.code as string, this.stateParams.state)
      .then(() => this.redirectAfterGenerate());
  }

  checkRequestValid(): boolean {
    return !!this.code && !!this.stateParams && this.scope === LoginScope.OFFLINE;
  }

  async redirectAfterGenerate() {
    const { from: name } = this.stateParams;

    const resolved = this.$router.resolve({ name });

    if (!resolved || resolved.href === '/') {
      throw new TypeError('Unknown redirect route');
    }

    return this.$router.push({ name });
  }
}
